import React from "react";

export default function MSAccess_Asc() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Asc</h1>
      <p>This is the MSAccess_Asc component generated from the SQL JSON.</p>
    </div>
  );
}
